define([
	"./_TextAlignVertical",
	"./PluginFactory"
], function(_TextVerticalAlign,PluginFactory) {

	return PluginFactory.declare(_TextVerticalAlign, {
		"class": "csi-button-toggle csi-toggle-group-last",
		cssValue: "flex-end",
		materialIcon: "vertical_align_bottom",
		pluginName: "verticalBottom",
		title: "CanvasAlignTextVerticalBottom"
	})
});
